import { render, staticRenderFns } from "./StickerBlock.vue?vue&type=template&id=742c3800&scoped=true"
import script from "./StickerBlock.vue?vue&type=script&lang=js"
export * from "./StickerBlock.vue?vue&type=script&lang=js"
import style0 from "./StickerBlock.vue?vue&type=style&index=0&id=742c3800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c3800",
  null
  
)

export default component.exports